/**
 * Message Queue Service
 *
 * Pure domain logic for creating messages with optimistic UI support.
 */
let counter = 0;
export function generateTempId() {
    counter++;
    return `msg-${Date.now()}-${counter}`;
}
export function createOptimisticMessage(content) {
    return {
        id: generateTempId(),
        role: 'user',
        content,
        timestamp: new Date(),
        status: 'sending',
    };
}
export function createAIMessage(content) {
    return {
        id: generateTempId(),
        role: 'assistant',
        content,
        timestamp: new Date(),
    };
}
export function createStreamingMessage() {
    return {
        id: generateTempId(),
        role: 'assistant',
        content: '',
        timestamp: new Date(),
    };
}
export function createDraftMessage(content, draft) {
    return {
        id: generateTempId(),
        role: 'assistant',
        content,
        timestamp: new Date(),
        draft,
    };
}
export const messageQueueService = {
    generateTempId,
    createOptimisticMessage,
    createAIMessage,
    createStreamingMessage,
    createDraftMessage,
};
export default messageQueueService;
